












import { defineComponent, ref } from '@vue/composition-api';
import Identity from './index';
const name = 'ttam-identity-post-new-authorize-compose';

export default defineComponent({
  name,
  components: {
    TtamIdentityTiktokPostAuthorizeButton: Identity.TtamIdentityTiktokPostAuthorizeButton,
    TtamIdentityTiktokPostAuthorizeDialog: Identity.TtamIdentityTiktokPostAuthorizeDialog,
  },
  props: {
    showTips: {
      type: Boolean,
      default: false,
    },
    smbTea: {
      type: Object,
      required: false,
    },
    ifButton: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const dialogVisible = ref(false);
    const onAdd = () => {
      dialogVisible.value = true;
    };
    const confirm = function () {
      emit('confirm');
    };
    const authVideo = function ({ id }) {
      emit('authVideo', { id });
    };
    return {
      onAdd,
      dialogVisible,
      confirm,
      authVideo,
      name,
    };
  },
});
